module.exports = __webpack_public_path__ + "img/claimed-ar.fb8bcdad.png";